import React from "react";
import styled from "styled-components";

const SimpleFooter = styled.div`
  text-align: left;
`;

const RightFooter = styled.div`
  display: flex;
  text-align: left;
  margin-top: 12px;

  @media (min-width: 615px) {
    text-align: right;
    margin-left: auto;
    margin-top: 0;
  }
`;

const FooterPhone = styled.a`
  flex-grow: 2;
  margin-top 0;

  @media (min-width: 615px) {
    text-align: right;
    order: 99;
  }
`;

export function Footer() {
  return (
    <div className="footer">
      <SimpleFooter className="footer_lower">
        <a href="/" className="footer_logo">
          Flick Electric
        </a>
        <div className="footer_utility">
          <a
            href="https://www.flickelectric.co.nz/careers"
            className="footer_utility_link"
          >
            Careers
          </a>
          <a
            href="https://www.flickelectric.co.nz/legals"
            className="footer_utility_link"
          >
            Legal
          </a>
          <a
            href="https://www.flickelectric.co.nz/newsroom"
            className="footer_utility_link"
          >
            Newsroom
          </a>
        </div>
        <span className="footer_utility_span">
          Copyright &copy; Flick Electric Co{" "}
          <script>document.write(new Date().getFullYear())</script>
        </span>
        <RightFooter>
          <FooterPhone href="tel:0800 435 425" className="footer_phone">
            0800 435 425
          </FooterPhone>
        </RightFooter>
      </SimpleFooter>
    </div>
  );
}

export default Footer;
